import axios from "axios";
import { config } from "../../Network_Calls/config";

export const getAllImplTag = async (impl_id,customer_id) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL + "/customer/cus_tags",
        {
          impl_id,
          customer_id
        },
        {
          ...config(),
        }
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.message;
    }
  };
  
  export const modifyImplTags = async (impl_id,customer_id,tagList) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL + "/customer/modify_tags",
        {
          impl_id,
          customer_id,
          tagList
        },
        {
          ...config(),
        }
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.message;
    }
  };

  export const getEngagementScore = async (
    impl_id,
    journey_type
  ) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/customer/engagement-score`,
        {
          impl_id,
          journey_type,
        },
        {
          ...config(),
        }
      );

      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  export const getInteractions = async (payload) => {

  const response = await axios.post(

    process.env.REACT_APP_SERVER_URL + "/interactions/getInteractions",

    payload,

    {
      ...config(),
    }
  );

  return response;
};